
//行业运营策略
import { get, post, postJson, put, deleteApi } from '../axios'

const RESOURCE_BASE_PATH = '/industry-strategy';

//我的使用策略
export const mineStrategy = p => get(`${ RESOURCE_BASE_PATH}/list/mine?current=${p.current}&size=${p.size}&strategyType=${p.strategyType}`);

//历史数据
export const historyData = p => get(`${ RESOURCE_BASE_PATH}/operationData/history?year=`+p);

//运营诊断数据查询
export const operationData  = p => get(`${ RESOURCE_BASE_PATH}/operationData`);

//行业运营策略列表
export const operationList  = p => get(`${ RESOURCE_BASE_PATH}/list`);

//自定义指标
export const indexCustom  = p => get(`${ RESOURCE_BASE_PATH}/index-custom`);

//自定义指标--系统默认数据
export const index  = p => get(`${ RESOURCE_BASE_PATH}/index`);

//自定义指标-保存
export const saveCustom = p => postJson(`${RESOURCE_BASE_PATH}/index-custom`, p);

//点击数据新增次数
export const getClickData  = p => get(`/industry-break/click-data`,p);

// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);

// 跳转过去京获客
export const toJHK = p => get(`/hd/redirect`, p);